import { Link } from 'react-router-dom';
import { menuItems, contactInfo } from '../data';

export default function Footer() {
  return (
    <footer className="bg-stone-900 text-stone-300 border-t border-stone-800">
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 py-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
        {/* Brand Column */}
        <div className="flex flex-col gap-6">
          <Link to="/" className="flex items-center gap-3 group">
            <img 
              src="https://assets.auxodev.dk/assets/eb528839-41b2-4674-9198-41967ffbbdbc/logo.png" 
              alt="Munkgaard Træbyg ApS" 
              className="h-16 w-auto object-contain brightness-0 invert"
            />
          </Link>
          <p className="text-sm text-stone-400 leading-relaxed">
            Specialister i kvalitetsbyggeri i træ. Vi bygger med fokus på det gode håndværk, ordentlighed og en grundig dialog fra start til slut.
          </p>
          {/* Social Icons */}
          <div className="flex items-center gap-4 mt-2">
            <a 
              href={contactInfo.facebook} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center text-white hover:bg-accent hover:text-white transition-all duration-300"
              aria-label="Besøg vores Facebook side"
            >
              <i className="fa-brands fa-facebook-f" />
            </a>
            <a 
              href={contactInfo.instagram} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="w-10 h-10 rounded-full bg-stone-800 flex items-center justify-center text-white hover:bg-accent hover:text-white transition-all duration-300"
              aria-label="Besøg vores Instagram profil"
            >
              <i className="fa-brands fa-instagram" />
            </a>
          </div>
        </div>

        {/* Quick Navigation */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-white text-base font-semibold tracking-wider uppercase">Hurtig navigation</h3>
          <ul className="flex flex-col gap-3 text-sm">
            {menuItems.map((item) => (
              <li key={item.label}>
                <Link to={item.href} className="hover:text-white hover:underline transition-colors">
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* Services / Offerings */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-white text-base font-semibold tracking-wider uppercase">Vi tilbyder</h3>
          <ul className="flex flex-col gap-3 text-sm text-stone-400">
            <li>
              <Link to="/vi-tilbyder/udhuse" className="hover:text-white transition-colors">
                Udhuse
              </Link>
            </li>
            <li>
              <Link to="/vi-tilbyder/tilbygning" className="hover:text-white transition-colors">
                Tilbygning
              </Link>
            </li>
            <li>
              <Link to="/vi-tilbyder/nybyggeri-i-trae" className="hover:text-white transition-colors">
                Nybyggeri i træ
              </Link>
            </li>
            <li>
              <Link to="/vi-tilbyder/totalrenovering" className="hover:text-white transition-colors">
                Totalrenovering
              </Link>
            </li>
            <li>
              <Link to="/vi-tilbyder/service" className="hover:text-white transition-colors">
                Service
              </Link>
            </li>
          </ul>
        </div>

        {/* Contact Info */}
        <div className="flex flex-col gap-6">
          <h3 className="font-display text-white text-base font-semibold tracking-wider uppercase">Kontaktoplysninger</h3>
          <div className="flex flex-col gap-4 text-sm">
            <a 
              href={contactInfo.mapsUrl} 
              target="_blank" 
              rel="noopener noreferrer" 
              className="flex items-start gap-3 hover:text-white transition-colors"
            >
              <i className="fa-solid fa-location-dot text-accent mt-1" />
              <span>{contactInfo.address}</span>
            </a>
            <a 
              href={`tel:${contactInfo.phoneRaw}`} 
              className="flex items-center gap-3 hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-phone text-accent" />
              <span>{contactInfo.phone}</span>
            </a>
            <a 
              href={`mailto:${contactInfo.email}`} 
              className="flex items-center gap-3 hover:text-white transition-colors whitespace-nowrap"
            >
              <i className="fa-solid fa-envelope text-accent" />
              <span>{contactInfo.email}</span>
            </a>
            <div className="flex items-center gap-3 text-stone-500 text-xs mt-2">
              <span>CVR nr.: {contactInfo.cvr}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Section */}
      <div className="bg-stone-950 text-stone-500 text-xs py-8 border-t border-stone-800/50">
        <div className="max-w-7xl mx-auto px-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p>© {new Date().getFullYear()} Munkgaard Træbyg ApS. Alle rettigheder forbeholdes.</p>
          <p className="tracking-wide">
            Udviklet med <i className="fa-solid fa-heart text-accent" /> i Danmark
          </p>
        </div>
      </div>
    </footer>
  );
}
